import { api } from "./api";

const conferenceService = api.injectEndpoints({
  endpoints: (builder) => ({
    //saveJournal
    registerMember: builder.mutation({
      query: (data) => ({
        url: "conferenceRegistration/createConferenceRegistration",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
    }),
    getAllRegisterMemberPagination: builder.mutation({
      query: (data) => ({
        url: "conferenceRegistration/getAllconferenceRegistrationPagination",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
    }),
    getAllMemberFees: builder.query({
      query: () => "conferenceFee/getAll",
    }),
    getMemberFeesById: builder.query({
      query: (id) => "conferenceFee/get/" + id,
    }),
    deleteRegistration: builder.mutation({
      query: (id) => ({
        url: "conferenceRegistration/delete/" + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
    }),
    checkMemberId: builder.mutation({
      query: (data) => ({
        url: "conferenceRegistration/checkMemberId",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body:data
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useRegisterMemberMutation,
  useDeleteRegistrationMutation,
  useGetAllRegisterMemberPaginationMutation,
  useGetAllMemberFeesQuery,
  useLazyGetAllMemberFeesQuery,
  useGetMemberFeesByIdQuery,
  useCheckMemberIdMutation
} = conferenceService;
